/**
 * Page de connexion Google Sign-In.
 */

import { renderHeader } from '../components/header.js';
import { createElement, clearElement, showToast } from '../utils/dom.js';
import { navigate } from '../router.js';
import { loginWithGoogle, isLoggedIn, GOOGLE_CLIENT_ID } from '../utils/auth.js';
import { initialSync, joinStore, pullData } from '../api/user-sync.js';

/**
 * @param {HTMLElement} container
 */
export async function renderLoginPage(container) {
  if (isLoggedIn()) {
    navigate('/');
    return;
  }

  clearElement(container);

  container.appendChild(renderHeader({
    title: 'GroceWise',
    showLogo: true,
    backPath: '/',
  }));

  const content = createElement('div', { className: 'page-content login-page' });

  const googleBtnContainer = createElement('div', {
    className: 'login-page__google-btn',
    attrs: { id: 'google-signin-btn' },
  });

  content.appendChild(createElement('div', {
    className: 'login-page__container',
    children: [
      createElement('img', {
        className: 'login-page__logo-img',
        attrs: { src: '/images/logo-text.png', alt: 'GroceWise', draggable: 'false' },
      }),
      createElement('h2', {
        className: 'login-page__title',
        text: 'Se connecter',
      }),
      createElement('p', {
        className: 'login-page__subtitle text-muted',
        text: 'Synchronisez vos listes sur tous vos appareils',
      }),
      googleBtnContainer,
    ],
  }));

  container.appendChild(content);

  // Initialiser le bouton Google après le rendu
  initGoogleButton(googleBtnContainer);
}

function initGoogleButton(container) {
  /* global google */
  const tryInit = () => {
    if (typeof google === 'undefined' || !google.accounts) {
      setTimeout(tryInit, 200);
      return;
    }

    google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: handleGoogleResponse,
      auto_select: false,
      ux_mode: 'popup',
    });

    google.accounts.id.renderButton(container, {
      theme: 'filled_blue',
      size: 'large',
      width: 300,
      text: 'signin_with',
      shape: 'pill',
      locale: 'fr',
    });
  };

  tryInit();
}

async function handleGoogleResponse(response) {
  if (!response.credential) {
    showToast('Erreur de connexion Google', 3000, 'error');
    return;
  }

  try {
    await loginWithGoogle(response.credential);
    await initialSync();

    const pendingJoin = localStorage.getItem('grocewise-pending-join');
    if (pendingJoin) {
      localStorage.removeItem('grocewise-pending-join');
      try {
        await joinStore(pendingJoin);
        await pullData();
        showToast('Connecté et liste rejointe !', 2000, 'success');
      } catch {
        showToast('Connecté ! Mais le code de partage est invalide.', 3000, 'error');
      }
    } else {
      showToast('Connecté !', 2000, 'success');
    }
    navigate('/');
  } catch (err) {
    showToast(err.message || 'Erreur de connexion', 3000, 'error');
  }
}
